module.exports = __webpack_public_path__ + "img/rebond-beauteRaisonnee.1e136261.jpg";